<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Text Reply Detail</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/message_report/reply_buttons">Text Reply</router-link>
                  </li>
                  <li class="breadcrumb-item active">Detail</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.period"
                  type="month"
                />
                <label class="focus-label">Period</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <multiselect
                  :class="'form-control'"
                  v-model="selectedContact"
                  id="ajax"
                  label="license_name"
                  track-by="id"
                  :placeholder="''"
                  :multiple="true"
                  open-direction="bottom"
                  :custom-label="customLabel"
                  :options="contactOptions"
                  :searchable="true"
                  :loading="isLoading"
                  :internal-search="false"
                  :close-on-select="false"
                  :options-limit="300"
                  :limit="3"
                  :limit-text="limitText"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="true"
                  @search-change="asyncFind"
                  :show-labels="false"
                >
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.license_name+" ("+option.license_phone_number+")" }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="selectedContact.length"
                      @mousedown.prevent.stop="clearAll(props.search)"
                    ></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <multiselect
                  :disabled="isDisabledButtons"
                  :class="'form-control'"
                  v-model="selectedContactButtons"
                  id="ajax"
                  label="license_name"
                  track-by="id"
                  :placeholder="''"
                  :multiple="true"
                  open-direction="bottom"
                  :custom-label="customLabelButtons"
                  :options="contactOptionsButtons"
                  :searchable="true"
                  :loading="isLoading"
                  :internal-search="false"
                  :close-on-select="false"
                  :options-limit="300"
                  :limit="3"
                  :limit-text="limitText"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="true"
                  @search-change="asyncFindButtons"
                  :show-labels="false"
                >
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.button_text+" ("+option.button_title+")" }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="selectedContact.length"
                      @mousedown.prevent.stop="clearAllButtons(props.search)"
                    ></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <a
                href="javascript:void(0)"
                @click.prevent="searchData"
                class="btn btn-success btn-block"
              >Search</a>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th class="text-center">License</th>
                      <th class="text-center">Button Text</th>
                      <th class="text-center">Phone Number</th>
                      <th class="text-center">Name</th>
                      <th class="text-center">Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="7">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row,index) in rows" :key="index">
                        <td class="text-right">{{row.number}}</td>
                        <td class="text-center">{{row.license_name}}</td>
                        <td class="text-center">
                          <div class="user-add-shedule-list">
                            <a href="javascript:void(0)">{{row.button_text}}</a>
                          </div>
                        </td>

                        <td class="text-center">
                          <a
                            :href="'https://api.whatsapp.com/send?phone='+getWhatsappNumberFromJid(row.message_number)"
                          >{{getWhatsappNumberFromJid(row.message_number)}}</a>
                        </td>
                        <td class="text-center">{{row.message_name}}</td>
                        <td
                          class="text-center"
                        >{{formatLocalDateWithDay(convertUTCDatetimeToUnix(row.create_datetime))}}</td>
                      </tr>
                    </template>
                    <template v-if="loading">
                      <tr>
                        <td colspan="5">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length<1 && !loading">
                      <tr>
                        <td colspan="5" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px;"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width:100px;"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="'btn '+{
                    disabled:
                      parseInt(currentPage) + 1 >
                      Math.ceil(totalRecords / serverParams.perPage)
                  }"
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import {
  convertUTCDatetimeToUnix,
  formatLocalDate,
  formatLocalDateWithDay,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  getWhatsappNumberFromJid
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect
  },
  data() {
    return {
      isDisabledButtons: false,
      isLoadingButtons: false,
      selectedContactButtons: [],
      contactOptionsButtons: [],
      contactListParamButtons: {
        columnFilters: { id: "", button_title: "", button_text: "" },
        page: 0,
        perPage: 20
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoading: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          license_id: "",
          period: this.getCurrentMonth(),
          auto_reply_button_id: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },

  watch: {
    selectedContactButtons: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedLicense = val;
        }
        if (val.length == 1) {
          this.serverParams.columnFilters.auto_reply_button_id = val[0].id;
          this.searchData();
        } else {
          this.serverParams.columnFilters.auto_reply_button_id = "";
          this.searchData();
        }
      },
      deep: true
    },
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedLicense = val;
        }
        if (val.length == 1) {
          this.serverParams.columnFilters.license_id = val[0].id;
          this.searchData();
        } else {
          this.serverParams.columnFilters.license_id = "";
          this.searchData();
        }
      },
      deep: true
    }
  },
  created() {
    this.asyncFind("");
    this.asyncFindButtons("");

    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    clearAllButtons() {
      console.log("lcear aalllll");
      this.selectedContactButtons = [];
    },
    asyncFindButtons(query) {
      this.isLoadingButtons = true;
      this.contactListParamButtons.columnFilters.button_text = query;
      if (
        typeof this.$route.query.auto_reply_button_id != "undefined" &&
        this.$route.query.auto_reply_button_id != ""
      ) {
        this.contactListParamButtons.columnFilters.id = this.$route.query.auto_reply_button_id;
        this.isDisabledButtons = true;
      }
      console.log("contactListParamButtons", this.contactListParamButtons);
      this.$store
        .dispatch("automation/listReplyButtons", this.contactListParamButtons)
        .then(response => {
          this.isLoadingButtons = false;
          this.contactOptionsButtons = response.data.data;
          if (
            typeof this.$route.query.auto_reply_button_id != "undefined" &&
            this.$route.query.auto_reply_button_id != ""
          ) {
            if (this.contactOptionsButtons.length > 0) {
              this.selectedContactButtons = this.contactOptionsButtons[0];
            }
          }
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoadingButtons = false;
        });
    },
    customLabelButtons({ button_text, button_title }) {
      return `${button_text} – ${button_title}`;
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ license_name, license_phone_number }) {
      return `${license_name} – ${license_phone_number}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.license_name = query;
      this.$store
        .dispatch("license/getLicenseList", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    },
    getWhatsappNumberFromJid(value) {
      return getWhatsappNumberFromJid(value);
    },
    labelStatusMessage(value) {
      return labelStatusMessage(value);
    },
    convertUTCDatetimeToUnix(utcDateTime) {
      return convertUTCDatetimeToUnix(utcDateTime);
    },
    formatLocalDate(unixtime) {
      return formatLocalDate(unixtime);
    },
    formatLocalDateWithDay(unixtime) {
      return formatLocalDateWithDay(unixtime);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      if (
        typeof this.$route.query.auto_reply_button_id != "undefined" &&
        this.$route.query.auto_reply_button_id != ""
      ) {
        this.serverParams.columnFilters.auto_reply_button_id = this.$route.query.auto_reply_button_id;
      }
      if (
        typeof this.$route.query.period != "undefined" &&
        this.$route.query.period != ""
      ) {
        this.serverParams.columnFilters.period = this.$route.query.period;
      }
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("messageReport/listButtonsDetailMonthly", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "summary_"
};
</script>


// WEBPACK FOOTER //
// src/views/messageReport/reply-buttons-detail.vue